import Maybe from 'components/__new/common/Maybe';
import { Input } from 'components/__new/common/form';
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getTransferBeneficiaries } from 'store/entities/transfers/action';
import { getAllBanks } from 'store/ui/banks/action';
import BeneficiariesList from '../BeneficiariesList';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import moment from 'moment';
import ReactSelect from 'react-select';
import { reactSelectStyles } from 'utils/reactSelectStyles';


const EditRecurringTransferAccountDetails = ({
    beneficiariesShown,
    setBeneficiariesShown,
    form,
    setForm,
    validatedBeneficiary,
    setValidatedBeneficiary,
    validationError,
    setValidationError,
    selectBeneficiary,
    banksLoading,
    banks,
    defaultForm,
    selected
}) => {
    
    const dispatch = useDispatch();
    const { getTransferBeneficiariesLoading, getTransferBeneficiariesData, recurringTransferForm } = useSelector((state) => state.entities.transfers)
    
    const banksData = useMemo(() => {
        return banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((singleBank) => ({
            label: singleBank?.bankName || singleBank?.institutionName,
            value: singleBank?.bankCode || singleBank?.institutionCode,
        })) || [];
    }, [banks])
    
    const updateBank = (value) => {
        const bank = banks?.find((bank) => (bank?.bankCode || bank?.institutionCode) === value)
        
        setForm({
            ...form,
            recipient: {
                ...form.recipient,
                bankCode: value,
                bankName: bank?.name,
                accountNumber: "",
            }
        })
        setValidatedBeneficiary(null);
        setValidationError(null);
    }
    
    
    useEffect(() => {
        dispatch(getAllBanks());
        dispatch(getTransferBeneficiaries({ type: "inter" }))
        setForm(defaultForm);
        // eslint-disable-next-line
    }, [])
    
    
    useEffect(() => {
        setForm({
        name: selected?.name || "",
        amount: selected?.amount || "",
        recipient: {
            accountNumber: selected?.recipient?.accountNumber || "",
            accountName: selected?.recipient?.accountName || "",
            bankName: selected?.recipient?.bankName || "",
            bankCode: selected?.recipient?.bankCode || "",
        },
        frequency: selected?.frequency || "",
        time: selected?.time?.substring(0, 5) || "12:00",
        dayOfWeek: selected?.dayOfWeek || "",
        dayOfMonth: selected?.dayOfMonth || "",
        startDate: moment(selected?.startDate).format('YYYY-MM-DD') || "",
        endDate: moment(selected?.endDate).format('YYYY-MM-DD') || "",
    })
        // eslint-disable-next-line
    }, [selected])
    
    
    useEffect(() => {
        if(recurringTransferForm !== null) {
            const {
                name, amount, frequency, startDate, endDate,
                recipient: { accountName, accountNumber, bankCode }
            } = recurringTransferForm;
            
            const bankObj = banks?.find((bank) => (bank?.bankCode || bank?.institutionCode) === bankCode)
            const bankName = bankObj?.name;
            
            setForm({
                name,
                amount,
                frequency,
                startDate,
                endDate,
                recipient: {
                    accountName, accountNumber, bankName, bankCode
                }
            })
        }
        // eslint-disable-next-line
    }, [recurringTransferForm])
    
    
    return (
        <div className="w-full pt-4 text-[#121619] space-y-7">
            <Input
                type="text"
                label="Recurring Transfer Name"
                value={form?.name || ""}
                className="form-input"
                onChange={(e) => setForm({...form, name: e.target.value})}
                placeholder="Enter a name for this recurring transfer"
            />
            
            <div className="form-group relative">
                <div className="w-full flex items-center justify-between">
                    <label>Bank Name</label>
                    <div onClick={() => setBeneficiariesShown(!beneficiariesShown)} className='text-sm cursor-pointer border-b border-ep-primary-600 text-ep-primary-600 pb-[0.5px]'>
                        {beneficiariesShown ? "Close search" : "Or Search Beneficiary List"}
                    </div>
                </div>
                
                {/* <select className='form-input' disabled={banksLoading} value={form?.recipient?.bankCode || ""} onChange={(e) => updateBank(e)}>
                    <option value="">{banksLoading ? "Fetching banks..." : "Select Bank"}</option>
                    {banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map(bank => (
                        <option key={bank.id} value={bank.code}>{bank.name}</option>
                    ))}
                </select> */}
                
                <ReactSelect
                    isDisabled={banksLoading}
                    isLoading={banksLoading}
                    isSearchable
                    name="bank_code"
                    onChange={(selected) => {
                        updateBank(selected.value);
                    }}
                    options={banksData}
                    styles={reactSelectStyles}
                    placeholder={banksLoading ? "Fetching banks..." : "Select Bank"}
                    noOptionsMessage={() => "No Banks Found"}
                />
                
                <Maybe condition={beneficiariesShown}>
                    <BeneficiariesList
                        selectBeneficiary={selectBeneficiary}
                        loading={getTransferBeneficiariesLoading}
                        beneficiaries={getTransferBeneficiariesData?.data?.docs}
                    />
                </Maybe>
            </div>
            
            <div className="form-group relative">
                <label>Account Number</label>
                <input
                    type="number"
                    id="prl-input"
                    className="form-input"
                    value={form.recipient.accountNumber || ""}
                    placeholder="Enter Number"
                    onChange={(e) => {setForm({...form, recipient: {...form.recipient, accountNumber: e.target.value}}); setValidatedBeneficiary(null)}}
                />
                
                <Maybe condition={validationError !== null}>
                    <div className="w-full flex items-center justify-start absolute -bottom-5">
                        <div className='ml-1.5 text-[#dc2626] capitalize text-xs'>
                            {validationError}
                        </div>
                    </div>
                </Maybe>
                
                <Maybe condition={validatedBeneficiary !== null && form?.recipient?.accountNumber?.length === 10}>
                    <div className="w-full flex items-center justify-start absolute -bottom-7">
                        <div className="flex items-center text-sm">
                            <IconCheckCircle width={15} />
                            <div className='ml-1.5 text-[#153344] capitalize text-xs'>{validatedBeneficiary?.toLowerCase()}</div>
                        </div>
                    </div>
                </Maybe>
            </div>
            

            <div style={{marginTop: validatedBeneficiary || validationError ? '35px' : "20px"}} className="form-group relative mt-5">
                <label>Amount to Transfer (Naira)</label>
                <input
                    type="number"
                    id="prl-input"
                    className="form-input !pl-7"
                    value={form.amount}
                    placeholder="0.00"
                    onChange={(e) => setForm({...form, amount: e.target.value})}
                />
                
                <div className="absolute left-3 top-7">₦&nbsp;</div>
            </div>
        </div>
    )
}

export default EditRecurringTransferAccountDetails